export default __webpack_public_path__ + "static/media/carousel-left-btn-disabled-icon.ebce03f9.svg";